import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import HeroCarousel from '../components/Landing/HeroCarousel';
import GoldCardSection from '../components/Landing/GoldCardSection';
import './LandingPage.css';

export default function LandingPage() {
  return (
    <div className="page-wrapper">
      <Header />
      <main className="main-content landing-main">
        <HeroCarousel />
        <GoldCardSection />
      </main>
      <Footer />
    </div>
  );
}
